import Rate from './rate';
import SelectCriteria from './selectCriteria';
import Write from './write';
import Evaluation from './evaluation';

export default {
  Rate, SelectCriteria, Write, Evaluation
};



// WEBPACK FOOTER //
// ./src/components/modals/rate/index.js